import { useField } from "formik";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export function CheckboxComponent(props) {
	const [field, meta, helpers] = useField(props.name);
	const { value } = meta;
	const { setValue } = helpers;
	const handleChange = event => {
		setValue(event.target.checked);
	  };
  
	return (
		<FormControlLabel
		control={<Checkbox
		  checked={value}
		  onChange={handleChange}
		  color="primary"
		  value={value}
		  disabled={props.disabled}
		/>}
		label={props.label}
		style={{left: (props.language=="ar")?'24.5rem':'0', marginTop:'10px'}}
		/>
	);
  }
